export default __webpack_public_path__ + "static/media/load.08e730ba.gif";